import Helper from '../../Utilities/Helpers/Helper';
/**
 * Supported tokens:
 * - column -> [column]
 * - input -> [value]
 * - rowData.colId -> [rowData.colId]
 */
export function resolvePlaceholders(text, context) {
    if (!text) {
        return text;
    }
    if (!context) {
        return text;
    }
    if (context === null || context === void 0 ? void 0 : context.input) {
        text = Helper.replaceAll(text, '[value]', context.input);
    }
    if (context === null || context === void 0 ? void 0 : context.column) {
        text = Helper.replaceAll(text, '[column]', context.api.columnApi.getFriendlyNameForColumnId(context.column.columnId));
    }
    if (context === null || context === void 0 ? void 0 : context.rowNode) {
        const columns = Helper.extractColsFromText(text);
        for (const column of columns) {
            if (context.api.columnApi.getColumnWithColumnId(column)) {
                text = Helper.replaceAll(text, `[rowData.${column}]`, context.api.gridApi.getRawValueFromRowNode(context.rowNode, column));
            }
        }
    }
    return text;
}
export const FormatContentHelper = {
    resolvePlaceholders,
};
export default FormatContentHelper;
